import { apiCall, createQueryString } from "../imports"

const PREFIX = "shop/products"

export default {
    importPricesExcel(data) {
        return apiCall('post', `${PREFIX}/prices/excel`, data)
    },

    getProductsPaginated(filters) {
        return apiCall('get', `${PREFIX}/paginated${createQueryString(filters)}`)
    },

    normalizeDatabase() {
        return apiCall('get', 'shop/normlize')
    },

    getProducts(filters) {
        return apiCall('get', `${PREFIX}${createQueryString(filters)}`)
    },

    getProduct(productID) {
        return apiCall('get', `${PREFIX}/${productID}`)
    },

    getProductRelations(productID) {
        return apiCall('get', `${PREFIX}/${productID}/relations`)
    },

    postProductRelation(productID, data) {
        return apiCall('post', `${PREFIX}/${productID}/relations`, data)
    },

    deleteProductRelation(productID, relationID) {
        return apiCall('delete', `${PREFIX}/${productID}/relations/${relationID}`)
    },

    getProductInfo(productId) {
        return apiCall('get', `${PREFIX}/${productId}/info`)
    },

    createProduct(data) {
        return apiCall('post', `${PREFIX}`, data)
    },

    updateProductInfo(productID, data) {
        return apiCall('post', `${PREFIX}/${productID}/info`, data)
    },

    toggleStatus(productID) {
        return apiCall('patch', `${PREFIX}/${productID}/status`)
    },

    deleteProduct(productID) {
        return apiCall('delete', `${PREFIX}/${productID}`)
    },

    updateProductDetail(productID, data) {
        return apiCall('post', `${PREFIX}/${productID}/details`, data)
    },

    getProductDetail(productID) {
        return apiCall('get', `${PREFIX}/${productID}/details`)
    },

    getProductImages(productID) {
        return apiCall('get', `${PREFIX}/${productID}/images`)
    },

    deleteProductImage(imageID) {
        return apiCall('delete', `${PREFIX}/images/${imageID}`)
    },

    setProductThumbnail(productID, data) {
        return apiCall('post', `${PREFIX}/${productID}/thumbnail`, data)
    },

    getProductPrices(productID) {
        return apiCall('get', `${PREFIX}/${productID}/prices`)
    },

    updateProductPrices(productID, data) {
        return apiCall('post', `${PREFIX}/${productID}/prices`, data)
    },

    deleteProductPrice(priceID) {
        return apiCall('delete', `${PREFIX}/prices/${priceID}`)
    },

    getProductFeaturables(productID) {
        return apiCall('get', `${PREFIX}/${productID}/featurables`)
    },

    getProductFeatureIds(productID) {
        return apiCall('get', `${PREFIX}/${productID}/featureids`)
    },

    updateProductFeatures(productID, data){
        return apiCall('post', `${PREFIX}/${productID}/features`,data)
    },

    getProductTags(productID) {
        return apiCall('get', `${PREFIX}/${productID}/tags`)
    },

    getProducTagsAndStandard(productID)
    {
        return apiCall('get', `${PREFIX}/${productID}/tags/standard`);
    },

    syncTags(productID,data){
        return apiCall('post', `${PREFIX}/${productID}/tags`,data)
    },

    syncTagStandard(productID, data) {
        return apiCall('post', `${PREFIX}/${productID}/tags/standard`, data);
    }


}